<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>统计分析</BreadcrumbItem>
      <BreadcrumbItem>活动分析</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <div style="text-align: right; width: 400px; margin: 0 auto 20px">
        <Input v-model.trim="searchKeyword" @on-enter="search(1)" size="large" placeholder="输入会议名称搜索">
        <Button slot="append" type="primary" icon="ios-search" @click="search(1)">搜索</Button>
        </Input>
      </div>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          活动统计分析
          <Input >
          <Button slot="append" icon="ios-search"></Button>
          </Input>
        </p>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'AttendeeList',
  data () {
    return {
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      remoteStatus: null,
      meetings: [],
      tableLoading: true,
      searchMobile: '',
      columns: [
        {
          title: '活动名称',
          key: 'title',
          minWidth: 250
        },
        {
          title: '发布时间',
          key: 'publishDate',
          render: (h, params) => {
            return h('span', this.formatDate(params.row.publishDate))
          }
        },
        {
          title: '举办地',
          key: 'address'
        },
        {
          title: '举办时间',
          key: 'startDate',
          width: 140,
          render: (h, params) => {
            return h('span', this.formatDate(params.row.startDate) + ' - ' + this.formatDate(params.row.endDate))
          }
        },
        {
          title: '浏览人数',
          key: 'viewCount'
        },
        {
          title: '报名人数',
          key: 'signCount'
        },
        {
          title: '审核通过人数',
          key: 'auditPassCount'
        },
        {
          title: '签到人数',
          key: 'signInCount'
        }
      ]
    }
  },
  computed: {
    rows () {
      return this.meetings
    }
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY/MM/DD HH:mm')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `?page=${startPage}&size=${this.pageSize}`
        if (this.searchKeyword) {
          queryStr += `&keyword=${this.searchKeyword}`
        }

        let resp = await this.$http.get(`/api/admin/statistics/mine/meetings${queryStr}`)
        this.totalCount = resp.body.totalElements
        this.totalPage = resp.body.totalPages
        this.meetings = resp.body.content
        this.$Loading.finish()
      } catch (e) {
        console.log(e)
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get('/api/admin/statistics/mine/meetings?page=1&size=20')
      next(vm => {
        vm.remoteStatus = resp.status
        vm.totalCount = resp.body.totalElements
        vm.totalPage = resp.body.totalPages
        vm.meetings = resp.body.content
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.meetings = []
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/statistics/mine/meetings?page=1&size=${this.pageSize}`)
      this.remoteStatus = resp.status
      this.totalCount = resp.body.totalElements
      this.totalPage = resp.body.totalPages
      this.meetings = resp.body.content
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.meetings = []
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/List.vue